import axios, { AxiosInstance } from "axios";

export const client: AxiosInstance = axios.create({
  baseURL: "https://api.admin-hansol.com",
  // baseURL: "http://15.164.142.137:8080",
});

export const setTokenToClient = (token: string) => {
  console.log("Token being set:", token); // 토큰 값 확인
  client.defaults.headers.common["Authorization"] = `Bearer ${token}`;
};
